import { useMutation } from '@tanstack/react-query';

import {
  useLeadEventsCache,
  mapRequestExternalValidationResponse,
  requestExternalValidation,
} from '../../accountCreation';

const EXTERNAL_VALIDATION_MUTATION_KEY = [
  'lead',
  'external-validation',
  'registration',
];

export function useRequestExternalValidation({
  onSuccess,
  onError,
  invalidateEventsOnSuccess = true,
} = {}) {
  const { invalidateLeadEvents } = useLeadEventsCache();

  return useMutation({
    mutationKey: EXTERNAL_VALIDATION_MUTATION_KEY,
    mutationFn: async () => {
      const dto = await requestExternalValidation();
      const mapped = mapRequestExternalValidationResponse(dto);
      if (!mapped.ok) {
        const err = new Error(mapped.errorCode);
        err.leadApiCode = mapped.errorCode;
        throw err;
      }
      return mapped.event;
    },
    onSuccess: (event) => {
      if (invalidateEventsOnSuccess) {
        void invalidateLeadEvents();
      }
      onSuccess?.(event);
    },
    onError,
  });
}
